export const FETCH_ORDER_TRACKING_SUCCESS = 'FETCH_ORDER_TRACKING_SUCCESS';
export const FETCH_ORDER_TRACKING_REQUEST = 'FETCH_ORDER_TRACKING_REQUEST';
export const FETCH_ORDER_TRACKING_FAILURE = 'FETCH_ORDER_TRACKING_FAILURE';
export const FETCH_ORDER_TRACKING_REST = 'FETCH_ORDER_TRACKING_REST';
export const fetchOrderTrackingSuccess = (payload) => ({
    type: FETCH_ORDER_TRACKING_SUCCESS,
    payload,
});
export const fetchOrderTrackingRequest = (payload) => ({
    type: FETCH_ORDER_TRACKING_REQUEST,
    payload,
});
export const fetchOrderTrackingFailure = (payload) => ({
    type: FETCH_ORDER_TRACKING_FAILURE,
    payload,
});
export const fetchOrderTrackingRest = () => ({
    type: FETCH_ORDER_TRACKING_REST,
});
